export default "__VITE_ASSET__CA79bkbZ__"